module.exports = __webpack_public_path__ + "img/icon-recording.eb7e6ae.svg";